export const Notification = () => {
  return <div>notification</div>;
};
